import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.DrawerPayAndCapturePromotion', {
    payDescription: 'The smarter, faster way to pay bills. Save time by paying approved bills directly in ApprovalMax.',
    captureDescription: 'Automated invoice data extraction in seconds. 100 free documents.',
    tryNowButtonText: 'Try now',
});
